import { useEffect, useRef } from 'react';

const useParallax = () => {
  const mouseRef = useRef({ x: 0.5, y: 0.5 });
  const rafRef = useRef(null);

  useEffect(() => {
    const SMOOTH_FACTOR = 0.08;
    let smoothMouse = { x: 0.5, y: 0.5 };

    // Track mouse position relative to viewport center
    const handleMouseMove = (e) => {
      mouseRef.current = {
        x: e.clientX / window.innerWidth,
        y: e.clientY / window.innerHeight
      };
    };

    window.addEventListener('mousemove', handleMouseMove);

    const animate = () => {
      // Smooth interpolation
      smoothMouse.x += (mouseRef.current.x - smoothMouse.x) * SMOOTH_FACTOR;
      smoothMouse.y += (mouseRef.current.y - smoothMouse.y) * SMOOTH_FACTOR;
      
      // Calculate offset from center (-0.5 to 0.5)
      const offsetX = smoothMouse.x - 0.5;
      const offsetY = smoothMouse.y - 0.5;
      
      // Apply to all parallax elements
      const elements = document.querySelectorAll('[data-parallax]');
      
      elements.forEach((element) => {
        const depth = parseFloat(element.dataset.parallax) || 0.02;
        const maxMove = depth * 100; // Convert to pixels based on viewport
        
        const translateX = offsetX * maxMove * window.innerWidth;
        const translateY = offsetY * maxMove * window.innerHeight;
        
        element.style.transform = `translate(${translateX}px, ${translateY}px)`;
      });
      
      rafRef.current = requestAnimationFrame(animate);
    };

    rafRef.current = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
      // Reset all elements
      document.querySelectorAll('[data-parallax]').forEach((el) => {
        el.style.transform = '';
      });
    };
  }, []);
};

export default useParallax;
